// extracted by mini-css-extract-plugin
module.exports = {"button":"NavigationButton-module--button--13lna","buttonActive":"NavigationButton-module--button--active--1C-oP"};